var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirtable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.52 2.309l-8.39 3.054a.6.6 0 0 0-.01 1.12l8.45 3.11a1.8 1.8 0 0 0 1.23 0l8.45-3.11a.6.6 0 0 0-.01-1.12l-8.39-3.054a1.8 1.8 0 0 0-1.33 0z",
    fill: "#FCB400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 11.47v9.27a.6.6 0 0 0 .82.56l9.1-3.63a.6.6 0 0 0 .38-.56V7.84a.6.6 0 0 0-.82-.56l-9.1 3.63a.6.6 0 0 0-.38.56z",
    fill: "#18BFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 11.47v9.27a.6.6 0 0 1-.82.56l-9.1-3.63a.6.6 0 0 1-.38-.56V7.84a.6.6 0 0 1 .82-.56l9.1 3.63a.6.6 0 0 1 .38.56z",
    fill: "#F82B60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 11.47v9.27a.6.6 0 0 1-.82.56l-9.1-3.63a.6.6 0 0 1-.38-.56V7.84l10.3 3.63z",
    fill: "#E8284B",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtable);
export default __webpack_public_path__ + "static/media/airtable.ba2db8733bce4dea9e59b4956aa1248a.svg";
export { ForwardRef as ReactComponent };